'use client';
import { SubscriptionTier } from '@/actions/dtos/subscription';
import { faGift } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface TrialInfoDisplayProps {
  isActive: boolean;
  daysLeft?: number;
  trialTier: SubscriptionTier;
  trialDurationDays: number;
}

const TrialInfo = ({ isActive, daysLeft, trialTier, trialDurationDays }: TrialInfoDisplayProps) => {
  return (
    <div className="flex items-center">
      <span className="mr-2">
        <FontAwesomeIcon icon={faGift} />
      </span>
      <p className="text-sm md:text-base">
        {isActive ? (
          <>
            {daysLeft === 0
              ? 'Du hast nur noch weniger als 1 Tag deiner kostenlosen ' + trialTier + '-Testphase!'
              : 'Du hast noch ' +
                daysLeft +
                ' ' +
                (daysLeft === 1 ? 'Tag' : 'Tage') +
                ' deiner kostenlosen ' +
                trialTier +
                '-Testphase!'}
          </>
        ) : (
          <>
            Starte jetzt deine {trialDurationDays}-tägige {trialTier}-Testphase kostenlos! Keine Kreditkarte
            erforderlich.
          </>
        )}
      </p>
    </div>
  );
};

export default TrialInfo;
